export default __webpack_public_path__ + "procreate.33a12c12.png";